/* flow */

import React from "react";
import { connect } from "react-redux";
import type { Action, ValidationErrors, RootState } from "../types";
import Form from "./Form";

type Config = {
  recaptchaSiteKey: string
};

type SandboxSignupProps = {
  dispatch: Action => Action,
  store: RootState,
  errors: ValidationErrors,
  countryCode: string,
  countries: Array<string>,
  config: Config
};

export const SandboxSignup = ({ dispatch, store }: SandboxSignupProps) => {
  return <Form store={store} dispatch={dispatch} />;
};

const mapStateToProps = (store: RootState) => ({ store });

// $FlowFixMe
export default connect(mapStateToProps)(Form);
